<template>
  <section class="case-study-sections d-flex flex-column">
    <div
      v-for="(section, idx) in sections"
      :key="idx"
      class="case-study-sections__section d-flex flex-column"
    >
      <TextSection
        :section="section"
        :index="idx"
        :case-study-id="caseStudyId"
        :editable="editable"
        :isIntroduction="true"
        v-if="section.type == 'introduction'"
      />
      <TextSection
        :section="section"
        :index="idx"
        :case-study-id="caseStudyId"
        :editable="editable"
        v-if="section.type == 'text'"
      />
      <TestimonialSection
        :section="section"
        :index="idx"
        :case-study-id="caseStudyId"
        :recipient-id="recipientId"
        :editable="editable"
        :accent-color="accentColor"
        v-if="section.type == 'testimonial'"
      />
      <KeyStatisticsSection
        v-if="section.type == 'key_statistics'"
        :editable="editable"
        :index="idx"
        :section="section"
        :accent-color="accentColor"
        :case-study-id="caseStudyId"
      ></KeyStatisticsSection>
      <ImageSection
        :section="section"
        :index="idx"
        :case-study-id="caseStudyId"
        :editable="editable"
        v-if="section.type == 'image'"
      />
      <VideoSection
        :section="section"
        :index="idx"
        :case-study-id="caseStudyId"
        :editable="editable"
        v-if="section.type == 'video'"
      />
      <SurveySnapshotSection
        :section="section"
        :accent-color="accentColor"
        :index="idx"
        :case-study-id="caseStudyId"
        :editable="editable"
        v-if="section.type == 'survey_snapshot'"
      />
    </div>
  </section>
</template>
<script lang="ts">
import TextSection from '@components/case_study_sections/TextSection.vue'
import KeyStatisticsSection from '@components/case_study_sections/KeyStatisticsSection.vue'
import ImageSection from '@components/case_study_sections/ImageSection.vue'
import VideoSection from '@components/case_study_sections/VideoSection.vue'
import TestimonialSection from '@components/case_study_sections/TestimonialSection.vue'
import SurveySnapshotSection from '@components/case_study_sections/SurveySnapshotSection.vue'

export default {
  components: {
    TextSection,
    ImageSection,
    KeyStatisticsSection,
    TestimonialSection,
    VideoSection,
    SurveySnapshotSection,
  },
  props: {
    sections: { type: Array, required: true },
    accentColor: { type: String, required: true },
    caseStudyId: { type: Number, required: true },
    recipientId: { type: Number, required: true },
    editable: { type: Boolean, required: false, default: false },
  },
}
</script>

<style lang="sass" scoped>
.case-study-sections
  gap: 18px
  &__section
    gap: 8px
    .title
      font-weight: var(--font-weight-bold)
      font-size: 16px
</style>
